const __WEBPACK_NAMESPACE_OBJECT__ = require("@solana/web3.js");